import { useMemo } from "react";

import { EditingContext, TEditingContext, TSubject } from "./Context";
import { TEditor } from "./Editor";

export const EditingProvider = <T extends TSubject>({
  children,
  current,
  start,
  complete,
}: {
  children: React.ReactNode;
} & TEditor<T>) => {
  const value = useMemo(
    () => ({ ...current, start, complete }),
    [current, start, complete]
  );
  return (
    <EditingContext.Provider value={value as TEditingContext<TSubject>}>
      {children}
    </EditingContext.Provider>
  );
};
